import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';

import { getString } from '../../../../helpers/stringHelpers.js';
import ContactDetailsCard from './ContactDetailsCard/ContactDetailsCard';
import PageHeading from '../../../../components/PageHeading/PageHeading';
import IndentedCardHeader from '../../../../components/IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../../../../components/IndentedCardContent/IndentedCardContent.js';
import ActionButton from '../../../../components/ActionButton/ActionButton';
import ContactDetailsDialog from './ContactDetailsDialog/ContactDetailsDialog';
import ConfirmedDialog from '../../../../components/ConfirmedDialog/ConfirmedDialog';
import ConfirmationDialog from '../../../../components/ConfirmationDialog/ConfirmationDialog';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'contactDetails';

class ContactDetailsSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editDialogOpen: false,
      confirmDialogOpen: false,
      initialDialogData: {
        mobilePhone: '',
        mobilePhoneName: '',
        mobilePhoneId: '',
        preferredPhone: '',
        preferredPhoneName: '',
        preferredPhoneId: '',
        email: '',
        emailId: '',
      },
      submitDialogData: {
        mobilePhone: '',
        mobilePhoneName: '',
        mobilePhoneId: '',
        preferredPhone: '',
        preferredPhoneName: '',
        preferredPhoneId: '',
        email: '',
        emailId: '',
      },
    };

    this.setDialogValues = this.setDialogValues.bind(this);
    this.toggleEditDialog = this.toggleEditDialog.bind(this);
    this.toggleConfirmDialog = this.toggleConfirmDialog.bind(this);
    this.handleConfirmed = this.handleConfirmed.bind(this);
    this.handleEditDialogSubmit = this.handleEditDialogSubmit.bind(this);
    this.handleConfirmDialogSubmit = this.handleConfirmDialogSubmit.bind(this);
  }

  handleConfirmed() {
    const { setConfirmedOpen } = this.props;
    setConfirmedOpen();
  }

  setDialogValues() {
    const { contactData } = this.props;

    this.setState({
      initialDialogData: {
        preferredPhone: contactData.preferredPhone,
        preferredPhoneName: contactData.preferredPhoneName,
        preferredPhoneId: contactData.preferredPhoneId,
        mobilePhone: contactData.mobilePhone,
        mobilePhoneName: contactData.mobilePhoneName,
        mobilePhoneId: contactData.mobilePhoneId,
        email: contactData.email,
        emailId: contactData.emailId,
      },
    });
  }

  toggleEditDialog() {
    this.setState({
      editDialogOpen: !this.state.editDialogOpen,
    });
  }

  toggleConfirmDialog() {
    this.setState({
      confirmDialogOpen: !this.state.confirmDialogOpen,
    });
  }

  handleEditDialogSubmit(dialogData) {
    this.setState({
      submitDialogData: dialogData,
    });
    this.toggleEditDialog();
    this.toggleConfirmDialog();
  }

  handleConfirmDialogSubmit() {
    const { updateContact } = this.props;
    const { submitDialogData, initialDialogData } = this.state;

    const contacts = [
      submitDialogData.mobilePhone != initialDialogData.mobilePhone ||
      submitDialogData.mobilePhoneName != initialDialogData.mobilePhoneName
        ? {
            contactName: submitDialogData.mobilePhoneName,
            value: submitDialogData.mobilePhone,
            type: 'mobilePhone',
            id: submitDialogData.mobilePhoneId,
          }
        : null,
      submitDialogData.preferredPhone != initialDialogData.preferredPhone ||
      submitDialogData.preferredPhoneName !=
        initialDialogData.preferredPhoneName
        ? {
            contactName: submitDialogData.preferredPhoneName,
            value: submitDialogData.preferredPhone,
            type: 'preferredPhone',
            id: submitDialogData.preferredPhoneId,
          }
        : null,
      submitDialogData.email != initialDialogData.email
        ? {
            contactName: 'Email',
            value: submitDialogData.email,
            type: 'email',
            id: submitDialogData.emailId,
          }
        : null,
      null,
      null,
    ];

    updateContact('1', contacts);
    this.toggleEditDialog();
  }

  render() {
    const { classes, contactData, confirmedOpen, canEdit } = this.props;
    const { initialDialogData, submitDialogData } = this.state;

    return (
      <div className={classes.root}>
        <Card>
          <IndentedCardHeader
            title={
              <div className={classes.heading}>
                <PageHeading
                  heading={getString(stringsComponent, 'MY_DETAILS_TITLE')}
                  isSubheading={true}
                />
                {contactData.updating ? (
                  <Typography compoment='span' className={classes.updating}>
                    {getString(stringsComponent, 'UPDATING_TEXT')}
                  </Typography>
                ) : (
                  canEdit && (
                    <ActionButton
                      icon={EditIcon}
                      action={() => {
                        this.setDialogValues();
                        this.toggleEditDialog();
                      }}
                      label={getString('profile', 'EDIT_BUTTON_LABEL')}
                      labelHidden={false}
                      withBorder={true}
                      withPadding={true}
                    />
                  )
                )}
              </div>
            }
            avatar={<PhoneOutlinedIcon />}
            classes={{
              avatar: classes.avatar,
            }}
          />
          <IndentedCardContent
            body={
              <div className={classes.negativeTopMargin}>
                <ContactDetailsCard
                  mobilePhone={contactData.mobilePhone}
                  mobilePhoneName={contactData.mobilePhoneName}
                  preferredPhone={contactData.preferredPhone}
                  preferredPhoneName={contactData.preferredPhoneName}
                  email={contactData.email}
                />
              </div>
            }
          />
        </Card>
        {this.state.editDialogOpen && (
          <ContactDetailsDialog
            initialDialogData={initialDialogData}
            open={this.state.editDialogOpen}
            handleSubmit={(dialogData) =>
              this.handleEditDialogSubmit(dialogData)
            }
            handleCancel={() => this.toggleEditDialog()}
          />
        )}
        {confirmedOpen && (
          <ConfirmedDialog
            title={getString(stringsComponent, 'CONFIRMED_TITLE')}
            open={confirmedOpen}
            close={this.handleConfirmed}
          />
        )}
        {this.state.confirmDialogOpen && (
          <ConfirmationDialog
            open={this.state.confirmDialogOpen}
            cancel={() => this.toggleConfirmDialog()}
            confirm={this.handleConfirmDialogSubmit}
            mobile={
              submitDialogData.mobilePhone != initialDialogData.mobilePhone
                ? submitDialogData.mobilePhone
                : null
            }
            mobileName={
              submitDialogData.mobilePhoneName !=
              initialDialogData.mobilePhoneName
                ? submitDialogData.mobilePhoneName
                : null
            }
            phone={
              submitDialogData.preferredPhone !=
              initialDialogData.preferredPhone
                ? submitDialogData.preferredPhone
                : null
            }
            phoneName={
              submitDialogData.preferredPhoneName !=
              initialDialogData.preferredPhoneName
                ? submitDialogData.preferredPhoneName
                : null
            }
            email={
              submitDialogData.email != initialDialogData.email
                ? submitDialogData.email
                : null
            }
            dialogText={getString(stringsComponent, 'CONFIRM_HELP_TEXT')}
          />
        )}
      </div>
    );
  }
}

ContactDetailsSection.propTypes = {
  canEdit: PropTypes.bool.isRequired,
};

export default withStyles(styles, { withTheme: true })(ContactDetailsSection);
